export function emptyTrick(index, leader) {
    return { index, leader, ledSuit: null, plays: [], winner: null, winning: null };
}
export function trickComplete(trick, activeSeatCount) {
    return trick.plays.length >= activeSeatCount;
}
export function cardPlayedBy(trick, seat) {
    return trick.plays.find((p) => p.seat === seat)?.card ?? null;
}
//# sourceMappingURL=trick.js.map